import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC, memo } from 'react';

import Grid2 from '../../components/grid/Grid2';
import { H2 } from '../../components/heading/Hx';
import List from '../../components/list/List';
import ListItem from '../../components/list/ListItem';
import Paragraph from '../../components/paragraph/Paragraph';
import Route from '../../components/route/Route';
import { RoutePath } from '../../components/route/type';
import Section from '../../components/section/Section';
import Video from '../../components/video/Video';
import { COLOR } from '../../theme/type';

const Alltag: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Section background={COLOR.Dark3}>
      <Grid2 spacing={{ md: '2rem', xs: '0' }}>
        <Grid2.Item>
          <H2>Selbstverteidigung im Alltag: Mehr als nur Gewalt</H2>

          <Paragraph>
            Selbstverteidigung im Alltag bezieht sich nicht nur auf körperliche
            Auseinandersetzungen, sondern auch auf die Kontrolle von unangemessenem Verhalten.
            Oftmals sind es subtile Übergriffe oder unangemessene Kommentare, die unsere Sicherheit
            und unser Wohlbefinden gefährden. Es ist entscheidend, solche Verhaltensweisen
            frühzeitig zu erkennen und darauf zu reagieren, bevor sie eskalieren. Hierbei spielt die
            Fähigkeit, auf sanfte Art Grenzen zu setzen und zu kommunizieren, eine zentrale Rolle,
            um respektvolle Beziehungen aufrechtzuerhalten.
          </Paragraph>

          {isMobile && <Video horizontal src={'1007005854'} />}

          <List bullets>
            <ListItem>
              Unsere Ansätze zur Selbstverteidigung im Alltag sind darauf ausgelegt, unauffällig und
              effektiv zu sein. Egal, ob es um subtile Übergriffe von Kollegen oder unangebrachte
              Kommentare von Familienmitgliedern geht – wir zeigen Dir, wie Du Konflikte
              deeskalierst, ohne die Beziehungen zu belasten. Unser Fokus liegt darauf, Dir das
              Vertrauen zu geben, in schwierigen Momenten ruhig und souverän zu handeln.
            </ListItem>
            <ListItem>
              Darüber hinaus ist es wichtig, Techniken zur Verarbeitung jedes Vorfalls zu erlernen.
              Emotionale Resilienz und die Fähigkeit, mit Stress umzugehen, sind entscheidend, um in
              schwierigen Situationen handlungsfähig zu bleiben. Indem wir unsere Belastbarkeit
              erhöhen und lernen allen Herausforderungen mit Entspannung zu begegnen, schaffen wir
              eine solidere Grundlage für zukünftige Herausforderungen.
            </ListItem>
          </List>
        </Grid2.Item>
        <Grid2.Item>{isMobile || <Video horizontal src={'1007005854'} />}</Grid2.Item>
      </Grid2>

      <Paragraph>
        Alle diese Fähigkeiten kannst Du bei uns im regulären{' '}
        <Route href={RoutePath.KampfkunstTraining}>Training</Route> erlernen. Komm gern vorbei und
        lerne uns kennen.
      </Paragraph>
    </Section>
  );
};

export default memo(Alltag);
